import { forgotPassword, forgotPasswordSubmit } from 'aws-auth-lib';
import { ensureAuthSuccess } from '../utils/authResult';

const ownEmail = (user) => {
    const email = typeof user?.email === 'string' ? user.email.trim() : '';
    if (!user?.uuid || !email) throw new Error('RESET_EMAIL_UNAVAILABLE');
    return email;
};

export const requestOwnPasswordReset = async (user) => {
    const result = ensureAuthSuccess(await forgotPassword(ownEmail(user)));
    if (result?.nextStep?.resetPasswordStep !== 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
        throw new Error('RESET_CODE_UNAVAILABLE');
    }
    const delivery = result.nextStep.codeDeliveryDetails;
    return {
        destination: delivery?.destination || '',
        medium: delivery?.deliveryMedium || ''
    };
};

export const confirmOwnPasswordReset = async (user, code, newPassword) =>
    ensureAuthSuccess(
        await forgotPasswordSubmit(ownEmail(user), code.trim(), newPassword)
    );

export const passwordResetErrorMessage = (error) => {
    switch (error?.name) {
        case 'CodeMismatchException':
            return 'O código é inválido. Verifique o código recebido.';
        case 'ExpiredCodeException':
            return 'O código expirou. Peça um novo código.';
        case 'InvalidPasswordException':
            return 'A nova palavra-passe não cumpre os requisitos de segurança da conta.';
        case 'PasswordHistoryPolicyViolationException':
            return 'Escolha uma palavra-passe que não tenha utilizado recentemente.';
        case 'LimitExceededException':
        case 'TooManyRequestsException':
            return 'Foram feitas demasiadas tentativas. Aguarde antes de tentar novamente.';
        case 'InvalidParameterException':
        case 'UserNotConfirmedException':
            return 'A recuperação não está disponível para esta conta. Contacte o administrador.';
        case 'CodeDeliveryFailureException':
            return 'Não foi possível enviar o código. Tente novamente.';
        default:
            return 'Não foi possível concluir a recuperação da palavra-passe. Tente novamente.';
    }
};
